var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
jade_mixins["settings-section"] = jade_interp = function(id, name, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("id", id, true, true)) + (jade.attr("data-id", id, true, true)) + (jade.attr("data-name", label || name, true, true)) + " class=\"settings-section js-settings-section\"><h2 class=\"settings-section__name\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</h2><div" + (jade.cls(['settings-section__main','js-settings-section__main--' + (id) + ''], [null,true])) + "><div" + (jade.cls(['settings-' + (id) + ''], [true])) + ">");
block && block();
buf.push("</div></div></div>");
};
jade_mixins["settings-section"].call({
block: function(){
jade_mixins["checkbox"] = jade_interp = function(name, disabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"settings-split artsy-checkbox\"><div class=\"settings-split__left\"><label" + (jade.attr("for", name, true, true)) + " class=\"artsy-checkbox--label js-settings-checkbox-label\">");
block && block();
buf.push("</label></div><div class=\"settings-split__right\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\"" + (jade.attr("id", name, true, true)) + (jade.attr("name", name, true, true)) + (jade.attr("checked", user && user.isChecked(name), true, true)) + (jade.attr("disabled", disabled, true, true)) + "><label" + (jade.attr("for", name, true, true)) + "></label></div></div></div>");
};
buf.push("<form class=\"stacked-form\"><div class=\"form-errors js-form-errors\"></div><label class=\"avant-garde-form-label\">Primary Location</label><div class=\"settings-about-you__location js-settings-about-you__location\"><input name=\"decoy-location\" placeholder=\"Enter your city\" class=\"bordered-input is-block\"></div><label for=\"profession\" class=\"avant-garde-form-label\">Profession</label><input type=\"text\" id=\"profession\" name=\"profession\"" + (jade.attr("value", user.get('profession'), true, true)) + " class=\"bordered-input\"><label class=\"avant-garde-form-label\">Price Range</label><label class=\"bordered-select\"><select name=\"price_range\"><option>Select a price range</option>");
// iterate user.priceBuckets
;(function(){
  var $$obj = user.priceBuckets;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var bucket = $$obj[$index];

buf.push("<option" + (jade.attr("value", bucket.value, true, true)) + (jade.attr("selected", (bucket.value === user.get('price_range') ? true : undefined), true, true)) + ">" + (jade.escape(null == (jade_interp = bucket.display) ? "" : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var bucket = $$obj[$index];

buf.push("<option" + (jade.attr("value", bucket.value, true, true)) + (jade.attr("selected", (bucket.value === user.get('price_range') ? true : undefined), true, true)) + ">" + (jade.escape(null == (jade_interp = bucket.display) ? "" : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select></label><label class=\"avant-garde-form-label\">Advanced Settings</label><div class=\"settings-about-you__advanced-settings\">");
jade_mixins["checkbox"].call({
block: function(){
buf.push("Share followed artists, categories, and galleries with your inquiries");
}
}, 'share_follows');
buf.push("</div><button class=\"avant-garde-button-white\">Save Changes</button></form>");
}
}, 'about-you', 'About You');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"artists-you-collect__description\">Adding artists that you collect will help Artsy and galleries to best serve your needs when answering your inquiry.</div><div class=\"artists-you-collect__user-interests js-artists-you-collect__user-interests\"></div>");
}
}, 'artists-you-collect', 'Artists You Collect');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<label class=\"avant-garde-form-label\">Preview</label><div class=\"settings-gallery-intro__preview js-settings-gallery-intro__preview\"></div>");
}
}, 'gallery-intro', 'Your Gallery Intro');}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;